import styles from './ViewEditScheme.module.css';

import { observer } from 'mobx-react-lite';
import SchemeEditor from '../../../SchemeEditor';
import React, { useEffect, useState } from 'react';
import { schemesStore } from '../../../../store/mobx/schemes.store';
import UpsertSchemeModal from '../UpsertSchemeModal';
import { SchemeModes } from '../../../../consts/scheme.consts';
import TextSwitch from '../../../../ui/TextSwitch';
import Tooltip from '../../../../ui/Tooltip';
import useAlert from '../../../../hooks/useAlert';

const MODE_TABS = [
  {
    label: 'Просмотр',
    value: SchemeModes.view,
  },
  {
    label: 'Редактирование',
    value: SchemeModes.edit,
  },
];

const ViewEditScheme = observer(() => {
  const { selectedScheme, setSelectedScheme, getByIdScheme, removeScheme, resetScheme } =
    schemesStore;
  const { showAlert } = useAlert();

  const [schemeEditModalOpened, setSchemeEditModalOpened] = useState(false);
  const [schemeSelectedMode, setSchemeSelectedMode] = useState(SchemeModes.view);

  useEffect(() => {
    loadProtocol();
  }, [selectedScheme?.id]);

  const loadProtocol = async () => {
    if (selectedScheme?.id) {
      const result = await getByIdScheme(selectedScheme?.id);
      setSelectedScheme({
        ...result,
      });
    }
  };

  const handleEditClick = () => {
    setSchemeEditModalOpened(true);
  };

  const handleModeChange = (value) => {
    setSchemeSelectedMode(value);
  };

  const handleDeleteClick = async () => {
    sureDeleteSchemeAlert(async () => {
      await removeScheme();
      resetScheme();
    });
  };

  const sureDeleteSchemeAlert = (callback) =>
    showAlert('Вы действительно хотите удалить данную схему?', 'sure', callback);

  const ToolbarActions = () => (
    <>
      <div className={styles.wrapperActions}>
        <TextSwitch selected={schemeSelectedMode} options={MODE_TABS} onChange={handleModeChange} />
        <Tooltip text={'Удалить'}>
          <div className={styles.deleteIcon} onClick={handleDeleteClick}></div>
        </Tooltip>
      </div>
      <div className={styles.titleContainer}>
        <div className={styles.tooltipContainer}>
          <Tooltip text={selectedScheme?.name} styleConfig={{ tooltip: styles.titleTooltip }}>
            <div className={styles.titleScheme}>{selectedScheme?.name}</div>
          </Tooltip>
        </div>
        <Tooltip text={'Переименовать'}>
          <div className={styles.editIcon} onClick={handleEditClick}></div>
        </Tooltip>
      </div>
    </>
  );

  return (
    <div className={styles.pageContainer}>
      <div className={styles.toolbar}>
        <ToolbarActions />
      </div>
      <div className={styles.schemeContainer}>
        <SchemeEditor mode={schemeSelectedMode} initialNodes={selectedScheme?.nodes} />
      </div>
      {schemeEditModalOpened && <UpsertSchemeModal setModalOpened={setSchemeEditModalOpened} />}
    </div>
  );
});

export default ViewEditScheme;
